export const sanitizeNumeric = (raw: string): string =>
  raw.replace(/[^0-9.]/g, '')

/**
 * Prevents the user from typing any character that is not 0-9 or '.'.
 * Arrow keys, tab, delete, etc. are allowed so normal navigation still works.
 */
export function numericKeyDown(e: React.KeyboardEvent<HTMLInputElement>): void {
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
  ]
  if (e.ctrlKey || e.metaKey || allowedKeys.includes(e.key)) {
    return
  }
  if (!/[0-9.]/.test(e.key)) {
    e.preventDefault()
  }
}
